<template>
  <div>
      <el-form  label-width="180px">
        <el-form-item label="绑定医院" >
          <el-select v-model="drughospital"  filterable  placeholder="请选择医院" :disabled="true" :multiple="false" popper-class="myselect" v-if="isEditMode">
            <el-option
              v-for="item in hospitallist"
              :key="item.id"
              :label="item.name"  
              :value="item.name">
            </el-option>
          </el-select>
          <el-select v-model="drughospitalList"  filterable  placeholder="请选择医院" :disabled="isComAdd?true:false" :multiple="true" popper-class="myselect" v-else>
            <el-option
              v-for="item in hospitallist"
              :key="item.id"
              :label="item.name"  
              :value="item.name">
            </el-option>
          </el-select>
       </el-form-item>
       <el-divider></el-divider>
        <el-form-item label="绑定药品">
          <el-select v-model="drugid"  filterable placeholder="请选择药品" :disabled="(isEditMode||isComAdd)?true:false">
            <el-option
              v-for="item in druglist"
              :key="item.id"
              :label="item.drugname+'/'+item.drugspec+'/'+item.drugcode"  
              :value="item.id">
              <span style="float: left">【药名】{{ item.drugname }}</span>
              <span style="float: left">【规格】{{ item.drugspec }}</span>
              <span style="float: left">【药厂】{{ item.drugfactory }}</span>
              <span style="float: left">【编码】{{ item.drugcode }}</span>
            </el-option>
          </el-select>
       </el-form-item>
       <el-divider></el-divider>
        <el-form-item label="小蜜蜂1" required>
          <el-col :span="8">
            <el-select v-model="form1.userid" clearable filterable >
              <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-form-item label="小蜜蜂1佣金">
             <el-input v-model="form1.commission"  placeholder="请输入佣金(元/盒)" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="有效期">
              <el-date-picker
                v-model="form1.startDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"	
                placeholder="选择开始时间">
              </el-date-picker>
              <el-date-picker
                v-model="form1.endDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="小蜜蜂2">
          <el-col :span="8">
            <el-select v-model="form2.userid" clearable filterable>
              <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-form-item label="小蜜蜂2佣金">
             <el-input v-model="form2.commission"  placeholder="请输入佣金(元/盒)" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="有效期">
              <el-date-picker
                v-model="form2.startDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"	
                placeholder="选择开始时间">
              </el-date-picker>
              <el-date-picker
                v-model="form2.endDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="小蜜蜂3">
          <el-col :span="8">
            <el-select v-model="form3.userid" clearable filterable>
              <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-form-item label="小蜜蜂3佣金">
             <el-input v-model="form3.commission"  placeholder="请输入佣金(元/盒)" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="有效期">
              <el-date-picker
                v-model="form3.startDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"	
                placeholder="选择开始时间">
              </el-date-picker>
              <el-date-picker
                v-model="form3.endDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="小蜜蜂4">
          <el-col :span="8">
            <el-select v-model="form4.userid" clearable filterable>
              <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-form-item label="小蜜蜂4佣金">
             <el-input v-model="form4.commission"  placeholder="请输入佣金(元/盒)" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="有效期">
              <el-date-picker
                v-model="form4.startDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"	
                placeholder="选择开始时间">
              </el-date-picker>
              <el-date-picker
                v-model="form4.endDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item>
          <el-button type="primary" @click="onSaveModify" v-if="isEditMode">更新佣金配置</el-button>
          <el-button type="primary" @click="onSaveAdd" v-else>保存佣金配置</el-button>
          <el-button type="default" @click="reset" v-if="!isEditMode&&!isComAdd">继续添加</el-button>
        </el-form-item>
      </el-form>
  </div>  
</template>
<script>
export default {
  data() {
    return {
      drugid:'',
      drughospital:'',
      drughospitalList:[],
      form1:{
        userid:'',
        commission: '',
        beeno:1,
        status:1 ,
        startDate:'',
        endDate:''
      },
      form2:{
        userid:'',
        commission: '',
        beeno:2,
        status:1,
        startDate:'',
        endDate:''
      },
      form3:{
        userid:'',
        commission: '',
        beeno:3,
        status:1,
        startDate:'',
        endDate:''
      },
      form4:{
        userid:'',
        commission: '',
        beeno:4,
        status:1,
        startDate:'',
        endDate:''
      },
      processing:false,
      druglist:[],
      hospitallist:[],
      userlist:[],

      isEditMode:false,
      isComAdd:false
    }
  },
  props: {
    comdrugcode: {type:String,default:''},
    comdrughospital:{type:String,default:''},
    comdrugid:{type:Number,default:0}
  },
  created(){
      this.isEditMode=(this.comdrugid!=0&&this.comdrughospital!='')?true:false
      if(this.isEditMode){
        this.initUserCommissionModify()
      }else{
        this.initUserCommissionAdd()
      }
  },
  methods: {
    async initUserCommissionAdd(){
        if(this.comdrugcode!=""&&this.comdrughospital!=""){
          this.isComAdd=true
          let matchInfo=await this.$post("/UserCommission/getDrugID",{drugcode:this.comdrugcode})
          if(!matchInfo.result.success){
              this.$message.error(matchInfo.result.info)
              return;
          }
          
          this.drugid=matchInfo.result.info
          this.drughospitalList.push(this.comdrughospital)
        }
        this.$post("/UserCommission/initAddUserCommission",{}).then((data)=>{
            if(data.result.success){
               this.druglist=data.result.info.druglist
               this.hospitallist=data.result.info.hospitallist
               this.userlist=data.result.info.userlist
            }
        })
    },
    onSaveAdd() {
        if(this.processing){
           this.$message.error("请等待处理完成");return false
        }
        if(this.drughospitalList.length==0){
           this.$message.error("请选择绑定医院");return false
        }
        if(this.drugid==""||this.drugid==undefined){
           this.$message.error("请选择绑定药品");return false
        }
        if(this.form1.userid==''){
          this.$message.error("请选择小蜜蜂1");return false
        }
        
        if(this.form1.commission==''||isNaN(this.form1.commission)||parseInt(this.form1.commission)<0){
          this.$message.error("小蜜蜂1佣金值设置非法");return false
        }
        
        if(this.form2.userid!=""&&this.form2.userid!=undefined){
          if(this.form2.commission==''||isNaN(this.form2.commission)||parseInt(this.form2.commission)<0){
              this.$message.error("小蜜蜂2佣金值设置非法");return false
          }
        }
        if(this.form3.userid!=""&&this.form3.userid!=undefined){
          if(this.form3.commission==''||isNaN(this.form3.commission)||parseInt(this.form3.commission)<0){
              this.$message.error("小蜜蜂3佣金值设置非法");return false
          }
        }
        if(this.form4.userid!=""&&this.form4.userid!=undefined){
          if(this.form4.commission==''||isNaN(this.form4.commission)||parseInt(this.form4.commission)<0){
              this.$message.error("小蜜蜂4佣金值设置非法");return false
          }
        }
        this.processing=true
        this.$post("/Usercommission/addUserCommissionSave",{form1:this.form1,form2:this.form2,form3:this.form3,form4:this.form4,drugid:this.drugid,drughospital:this.drughospitalList}).then((data)=>{
             this.processing=false
             if(data.result.success){
                 this.$message({message:data.result.info,type:'success'})
             }else{
                 this.$message.error(data.result.info)
             }
        })
    },
   initUserCommissionModify(){
        
        this.drugid=this.comdrugid
        this.drughospital=this.comdrughospital
        
        this.$post("/UserCommission/initUserCommissionModify",{drugid:this.drugid,drughospital:this.drughospital}).then((data)=>{
            if(data.result.success){
               this.druglist=data.result.info.druglist
               this.hospitallist=data.result.info.hospitallist
               this.userlist=data.result.info.userlist
               this.form1=data.result.info.form1
               this.form2=data.result.info.form2
               this.form3=data.result.info.form3
               this.form4=data.result.info.form4
            }
        })
    },
    onSaveModify() {
        if(this.processing){
           this.$message.error("请等待处理完成");return false
        }
        if(this.drughospital==""||this.drughospital==undefined){
           this.$message.error("请选择绑定医院");return false
        }
        if(this.drugid==""||this.drugid==undefined){
           this.$message.error("请选择绑定药品");return false
        }
        if(this.form1.userid==''){
          this.$message.error("请选择小蜜蜂1");return false
        }
        
        if(this.form1.commission==''||isNaN(this.form1.commission)||parseInt(this.form1.commission)<0){
          this.$message.error("小蜜蜂1佣金值设置非法");return false
        }
        
        if(this.form2.userid!=""&&this.form2.userid!=undefined){
          if(this.form2.commission==''||isNaN(this.form2.commission)||parseInt(this.form2.commission)<0){
              this.$message.error("小蜜蜂2佣金值设置非法");return false
          }
        }
        if(this.form3.userid!=""&&this.form3.userid!=undefined){
          if(this.form3.commission==''||isNaN(this.form3.commission)||parseInt(this.form3.commission)<0){
              this.$message.error("小蜜蜂3佣金值设置非法");return false
          }
        }
        if(this.form4.userid!=""&&this.form4.userid!=undefined){
          if(this.form4.commission==''||isNaN(this.form4.commission)||parseInt(this.form4.commission)<0){
              this.$message.error("小蜜蜂4佣金值设置非法");return false
          }
        }
        this.processing=true
        this.$post("/Usercommission/saveUserCommissionModify",{form1:this.form1,form2:this.form2,form3:this.form3,form4:this.form4,drugid:this.drugid,drughospital:this.drughospital}).then((data)=>{
             this.processing=false
             if(data.result.success){
                 this.$message({message:data.result.info,type:'success'})
             }else{
                 this.$message.error(data.result.info)
             }
        })
    },
    reset(){
      this.drugid=''
      this.drughospital=''
      this.drughospitalList=[]
      this.form1={
        userid:'',
        commission: '',
        beeno:1,
        status:1,
        startDate:'',
        endDate:'' 
      }
      this.form2={
        userid:'',
        commission: '',
        beeno:2,
        status:1,
        startDate:'',
        endDate:''
      }
      this.form3={
        userid:'',
        commission: '',
        beeno:3,
        status:1,
        startDate:'',
        endDate:''
      }
      this.form4={
        userid:'',
        commission: '',
        beeno:4,
        status:1,
        startDate:'',
        endDate:''
      }
      this.processing=false
      this.isEditMode=false
      this.isComAdd=false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-divider--horizontal {
margin-top:50px!important;
}
/deep/ .el-select .el-input {width: 350px!important}

</style>
